<template>
  <div class="content-wrapper p-3 p-md-4">
    <div class="mb-3">
      <h4 class="mb-1">ผู้ใช้และสิทธิ์</h4>
      <small class="text-muted">{{ clinicName }} — ระดับคลินิก</small>
    </div>

    <b-tabs lazy content-class="pt-3">
      <b-tab title="ผู้ใช้ในคลินิก" active>
        <ClinicUsers />
      </b-tab>
      <b-tab title="แพทย์">
        <ClinicDoctors />
      </b-tab>
      <b-tab title="Audit log">
        <AuditLog />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ClinicUsers from "@/views/central/ClinicUsers.vue";
import ClinicDoctors from "@/views/central/ClinicDoctors.vue";
import AuditLog from "@/views/central/AuditLog.vue";

export default {
  name: "ClinicUserManagement",
  components: {
    ClinicUsers,
    ClinicDoctors,
    AuditLog,
  },
  computed: {
    ...mapGetters({ getClinicList: "moduleUser/getClinicList" }),
    clinicUrl() {
      return this.$route.params.clinicUrl;
    },
    clinicName() {
      const c = (this.getClinicList || []).find(x => x.code === this.clinicUrl);
      return c ? c.name : this.clinicUrl;
    },
  },
  created() {
    // Central route has no branchUrl, so requiresDataFetch / checkLogin do not
    // populate clinicList. Load it here so Navbar + page header can resolve the
    // clinic name on hard refresh.
    this.fetchClinicList().catch(() => {});
  },
  methods: {
    ...mapActions({ fetchClinicList: "moduleUser/fetchClinicList" }),
  },
};
</script>
